import { BookingRequest } from '@prisma/client';
import { useHistory } from 'react-router-dom';
import api from '../../../api';
import TableRowAction from '../../../components/tables/TableRowAction';
import icons from '../../../icons';
import { useDialogs } from '../../../state/dialogs';
import { useIntl } from '../../../state/intl';
import { useAPIMutation } from '../../../utils/hooks/api.hooks';
import useErrors from '../../../utils/hooks/errors.hooks';
import useSnacks from '../../../utils/hooks/snacks.hooks';

interface BookingRequestRowActionProps {
  bookingRequest: BookingRequest;
  archived?: boolean;
}

const BookingRequestRowAction: React.FC<BookingRequestRowActionProps> = ({
  bookingRequest,
  archived = false,
}) => {
  const { txc } = useIntl();
  const handleErr = useErrors();
  const { confirm } = useDialogs();
  const { showSuccess } = useSnacks();
  const history = useHistory();

  async function performRestore() {
    try {
      await api.request('bookingRequests/restore', { id: bookingRequest.id });
      showSuccess();
      history.push('/booking-requests/' + bookingRequest.id);
    } catch (err) {
      handleErr(err);
    }
  }

  function onRestore() {
    confirm({
      title: 'Restore booking request',
      content: 'Do you really want to restore this booking request and every related data?',
      onMainAction: performRestore,
    });
  }

  const [performDelete] = useAPIMutation('bookingRequests/delete', {
    onSuccess: () => showSuccess(),
    queries: ['bookingRequests/list'],
  });

  function onDelete() {
    confirm({
      title: 'Delete booking request',
      content: (
        <>
          {'This will permanently delete this booking request and every related data:'}
          <ul>
            <li>Notes</li>
          </ul>
          {'Do you want to proceed?'}
        </>
      ),
      onMainAction: () =>
        performDelete({
          id: bookingRequest.id,
        }),
    });
  }

  return (
    <>
      {!archived ? (
        <TableRowAction
          label={txc.details}
          icon={icons.details}
          onClick={() => history.push('booking-requests/' + bookingRequest.id)}
        />
      ) : null}

      {archived ? (
        <TableRowAction label={txc.actions.restore} icon={icons.unarchive} onClick={onRestore} />
      ) : null}

      {archived ? (
        <TableRowAction label={txc.actions.delete} icon={icons.delete} onClick={onDelete} />
      ) : null}
    </>
  );
};

export default BookingRequestRowAction;
